import script from "./PayinDetailsDialogWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./PayinDetailsDialogWrapper.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__